/**
 * MainPage — 메인(index) 페이지 전용: 한자 히어로(GSAP), NEWS 비밀글, About 패럴랙스
 */

const STROKE_START_DELAY = 0.15;
const STROKE_DURATION = 2;
const FILL_START_DELAY = 1.5; // stroke 끝(2.55) + 0.25초
const FILL_DURATION = 0.5;
const HERO_DELAY_AFTER_SPLASH = 250;

export const MainPage = {
    /** 메인 페이지일 때만 호출 (hero-title-svg 또는 .no-main-visual--renew 존재 시) */
    init() {
        this.initNewsPasswordLinks();
        this.initHeroDrawing();
        this.initParallax();
    },

    /** 메인 NEWS 섹션 비밀글 링크 → 비밀번호 모달 */
    initNewsPasswordLinks() {
        document.addEventListener("click", (e) => {
            const link = e.target.closest(
                ".no-news-blog__link-password, [data-password-protected='true']",
            );
            if (
                !link ||
                link.getAttribute("data-password-protected") !== "true"
            )
                return;
            e.preventDefault();
            const postId = link.getAttribute("data-post-id");
            const viewRoute =
                link.getAttribute("data-view-route") || "news.resource-view";
            if (postId && typeof window.openBoardPasswordModal === "function") {
                window.openBoardPasswordModal(postId, viewRoute);
            }
        });
    },

    /** 한자(幸福) stroke → fill GSAP 타임라인, 설명글(motto) 트리거 */
    initHeroDrawing() {
        const wrap = document.getElementById("hero-title-svg");
        if (!wrap) return;

        const paths = wrap.querySelectorAll(".hero-title-path");
        const gsap = window.gsap;
        if (!gsap) {
            this._heroDrawingFallback(wrap, paths);
            return;
        }

        const run = () => {
            document.body.classList.add("hero-animation-started");

            const lengths = [];
            paths.forEach((path) => {
                const len = path.getTotalLength();
                lengths.push(len);
                path.setAttribute("stroke-dasharray", len);
                gsap.set(path, {
                    strokeDashoffset: len,
                    fillOpacity: 0,
                });
            });

            gsap.set(wrap, { opacity: 1, visibility: "visible" });

            const tl = gsap.timeline();
            tl.to(
                paths,
                {
                    strokeDashoffset: 0,
                    duration: STROKE_DURATION,
                    ease: "power2.inOut",
                },
                STROKE_START_DELAY,
            );
            tl.to(
                paths,
                {
                    fillOpacity: 1,
                    duration: FILL_DURATION,
                    ease: "power2.out",
                },
                FILL_START_DELAY,
            );
        };

        if (document.getElementById("splash-mask")) {
            window.addEventListener(
                "splashEnded",
                () => setTimeout(run, HERO_DELAY_AFTER_SPLASH),
                { once: true },
            );
        } else {
            run();
        }
    },

    /** GSAP 없을 때 기존 클래스 방식 폴백 */
    _heroDrawingFallback(wrap, paths) {
        const run = () => {
            document.body.classList.add("hero-animation-started");
            paths.forEach((path) => {
                const len = path.getTotalLength();
                if (len > 0) {
                    path.setAttribute("stroke-dasharray", len);
                    path.setAttribute("stroke-dashoffset", len);
                }
            });
            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    wrap.style.opacity = "";
                    wrap.style.visibility = "";
                    wrap.classList.add("is-ready");
                });
            });
            setTimeout(() => wrap.classList.add("is-drawing"), 150);
            setTimeout(() => wrap.classList.add("is-filled"), 2800);
        };
        if (document.getElementById("splash-mask")) {
            window.addEventListener(
                "splashEnded",
                () => setTimeout(run, HERO_DELAY_AFTER_SPLASH),
                { once: true },
            );
        } else {
            run();
        }
    },

    /** Main About 섹션 스크롤 패럴랙스 (--parallax-offset) */
    initParallax() {
        const section = document.querySelector("[data-parallax-section]");
        if (!section) return;

        const rate = 0.2;
        const update = () => {
            const rect = section.getBoundingClientRect();
            const center = rect.top + rect.height * 0.5;
            const viewportCenter = window.innerHeight * 0.5;
            const offset = (viewportCenter - center) * rate;
            section.style.setProperty("--parallax-offset", Math.round(offset));
        };
        update();
        window.addEventListener("scroll", update, { passive: true });
        window.addEventListener("resize", update);
    },
};
